type LaravelValidationError = {
    [key: string]: string[];
  };
  export const parseValidationErrors = (
    error: any
  ): Record<string, string> => {
    const errorBag: Record<string, string> = {};
    if (error && typeof error === 'object') {
      const errors: LaravelValidationError = error;
      for (const field in errors) {
        if (Array.isArray(errors[field]) && errors[field].length > 0) {
          errorBag[field] = errors[field][0];
        }
      }
    }
    return errorBag;
  };
  